<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/bookList' }">
					<i class="el-icon-s-custom"></i> 绘本列表
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加绘本</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'绘本名称'" prop="mdaNAME">
							<el-input v-model="ruleForm.mdaNAME" :placeholder="'请输入绘本名称'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'绘本条码'" prop="mdaCODE">
							<el-input v-model="ruleForm.mdaCODE" :placeholder="'请输入绘本条码'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'类型分类'" prop="mdaLSFL">
							<el-select v-model="ruleForm.mdaLSFL" clearable filterable :placeholder="'请选择类型分类'">
								<el-option v-for="item in ruleForm.optionsSORT1" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'年龄分类'" prop="mdaNLFL">
							<el-select v-model="ruleForm.mdaNLFL" clearable filterable :placeholder="'请选择年龄分类'">
								<el-option v-for="item in ruleForm.optionsSORT2" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'出版社分类'" prop="mdaCBFL">
							<el-select v-model="ruleForm.mdaCBFL" clearable filterable :placeholder="'请选择出版社分类'">
								<el-option v-for="item in ruleForm.optionsSORT3" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'出版社名称'" prop="mdaPRES">
							<el-input v-model="ruleForm.mdaPRES" :placeholder="'请输入出版社名称'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<el-form-item :label="'绘本封面'" prop="mdaIMGU" >
							<el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
								<el-image v-if="ruleForm.mdaIMGU" fit="fill" disabled :src="ruleForm.mdaIMGU" :onerror="defaultImg" class="avatar"></el-image>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">

						<el-form-item :label="'绘本音频'" prop="mdaAUDU" >
							<el-upload 
							 action=""
							 :show-file-list="false"
							 :auto-upload="false"
							 :on-change="uploadAudio"
							 class="audio-uploader">
								<!-- <el-image v-if="ruleForm.maaAUDU" fit="fill" disabled :src="ruleForm.maaAUDU" :onerror="defaultImg" class="avatar"></el-image>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
								<el-col :span="6">
									<el-button size="small" type="primary" class="btnClick">点击上传</el-button>             
								</el-col>
								
								<el-col :span="6">
									<el-button size="small" type="danger" class="btnClick" @click="deleteAudio($event)">删除音频</el-button>             
								</el-col>
									   
								<el-col :span="18">                
									<audio ref="audioPlay" controlsList="nodownload" class="audio-player" :src="ruleForm.mdaAUDU" controls> 你的浏览器不支持 <code>audio</code> 标签.</audio>
								</el-col>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
				

				<el-row style="margin: 0 !important;">
					<el-col :span="12" >
						<el-form-item :label="'故事介绍：'" prop="mdaSTOR">
							<el-input v-model="ruleForm.mdaSTOR" clearable type="textarea" rows="10" size="medium" maxlength="1000" show-word-limit></el-input>
						</el-form-item>
					</el-col> 
				</el-row>
				
				
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button :loading="submitFormLoading" type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
				<el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
					<div class="cropper-content">
						<div class="cropper" style="text-align:center">
						<vueCropper
							ref="cropper"
							:img="imgCutOption.img"
							:outputSize="imgCutOption.size"
							:outputType="imgCutOption.outputType"
							:info="true"
							:full="imgCutOption.full"
							:canMove="imgCutOption.canMove"
							:canMoveBox="imgCutOption.canMoveBox"
							:original="imgCutOption.original"
							:autoCrop="imgCutOption.autoCrop"
							:fixed="imgCutOption.fixed"
							:fixedNumber="imgCutOption.fixedNumber"
							:centerBox="imgCutOption.centerBox"
							:infoTrue="imgCutOption.infoTrue"
							:fixedBox="imgCutOption.fixedBox"
						></vueCropper>
						</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="imgCutVisible = false">返回</el-button>
						<el-button type="primary" @click="finish">提交</el-button>
					</div>
				</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addBook',
		inject: ['reload'],
		data() {

			//验证字符串
			const validateCode = (rule,value,callback)=>{
				const self_agent = this;
				
				if(self_agent.ruleForm.mdaCODE.trim().length == 0){
					callback(new Error('请输入绘本条码'));
					return;
				}
				
				var postUrl='WCF/WEB/svcMAA.svc/CheckMDAInfo';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sMSID: self_agent.ruleForm.mdaMSID ,
						sName: '' ,
						sCode: self_agent.ruleForm.mdaCODE
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resStr = response.data.KKSTR;
					if(resStr == 'Y'){
						callback();
					}else if(resStr == 'N'){
						callback(new Error('条码重复'))
					}
				})
				.catch((error) =>{
					callback(new Error('检查条码失败，请检查网络'))
				});
			}
			return {
				audioUploadPercent: 0,
				fileList: [],
				submitFormLoading: false, // 提交按钮load效果
				
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				flag: true,
				imgCutVisible: false,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpeg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1.4], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				defaultImg: 'this.src="' + require("../../assets/img/users_128.png") + '";this.onerror=null',
				
				SABSADIdisabled:false,
				HADSABIdisabled:true,
				page:1,
				changeData: {},
				ruleForm: {
					optionsDELF: [],
					mdaIMGU: '',
					mdaAUDU: '',
					mdaNAME: '',
					mdaCODE: '',
					mdaPRES: '',
					mdaSTOR: '',
					mdaAUDL: '',
					imgbase64: '',
					audioBase64: '',
					mdaLSFL: '',
					optionsSORT1: [],
					mdaNLFL: '',
					optionsSORT2: [],
					mdaCBFL: '',
					optionsSORT3: [],

				},
				rules: {
					mdaNAME: [{
						required: true,
						message: '请输入绘本名称', 
						trigger: ['blur', 'change'],
						
					}],
					mdaCODE: [{
						required: true,
						// message: '请输入绘本条码', 
						trigger: ['blur', 'change'],
						validator: validateCode
					}],
					mdaPRES: [{
						required: true,
						message: '请输入出版社', 
						trigger: ['blur', 'change']
					}],
	
					mdaIMGU: [{
						required: true,
						message: '请上传绘本封面',
						trigger: ['blur', 'change']
					}],
					mdaSTOR: [{
						required: true,
						message: '请填写故事介绍',
						trigger: ['blur', 'change']
					}],
					mdaAUDU: [{
						required: false
					}],
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editChild") {
					this.dummyCreated();
				}
			}
		},
		created() {
			// this.page=this.$route.query.page;
			this.getMTP('1')
			this.getMTP('2')
			this.getMTP('3')
		},
		
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			deleteAudio(event){
				event.stopPropagation();
				this.ruleForm.mdaAUDU = '';
				this.ruleForm.audioBase64 = '';
				this.ruleForm.mdaAUDL = '';
			},
			getMTP(key) {
				const that = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/GetMTPList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
							sKEY:key
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							if (key=='1')
							{
								this.ruleForm.optionsSORT1 = response.data.KKDT;
							}
							else if(key=='2')
							{
								this.ruleForm.optionsSORT2 = response.data.KKDT;
							}
							else if(key=='3')
							{
								this.ruleForm.optionsSORT3 = response.data.KKDT;
							}
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			dummyCreated () {
				this.getMTP('1')
				this.getMTP('2')
				this.getMTP('3')
			},

			// 上传音频
			uploadAudio(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'audio/mp3' || file.raw.type == 'audio/mpeg') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传音频只能是 MP3 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传音频大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}
							
				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.ruleForm.mdaAUDU = this.result;
						that.ruleForm.audioBase64 = this.result;
						that.ruleForm.mdaAUDL = that.$refs.audioPlay.duration;
						// console.log(that.$refs.audioPlay)
						that.getAudioLong(file);
					}
				}
			},
			// 获取音频时长
			getAudioLong(file){
				let that = this;
				
				// var url = URL.createObjectURL(file);
				// var audioElement = new Audio(file);
				// audioElement.load();
				// audioElement.oncanplay = function () {
				// 	console.log(audioElement.duration)
				// 	that.ruleForm.maaAUDL = parseInt(audioElement.duration) * 1000;
				// }
				that.$refs.audioPlay.addEventListener("loadedmetadata", function(_event) {
					// 分钟
					let time = (parseInt(that.$refs.audioPlay.duration) / 60).toString();
					let min = time.split('.')[0] + '分';
					let sec = (parseInt(time.split('.')[1]) * 60 / 100).toString() + '秒';
					sec = sec.length > 2 ? parseInt(sec.substring(0,2)) : sec;
					sec += '秒';
					that.ruleForm.mdaAUDL = min + sec; //时长为秒，取整
					console.log(that.ruleForm.mdaAUDL)
				});
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}
			
				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						// that.ruleForm.imageUrl = this.result;
						// that.ruleForm.imgbase64 = this.result.split(',')[1];
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						that.ruleForm.mdaIMGU = this.result;
						that.ruleForm.imgbase64 = this.result;
						that.imgCutVisible = false;
					}
				})
			},
			//保存绘本信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
	
						const self = this;
						this.submitFormLoading = true;
		
						var postUrl = 'WCF/WEB/svcMAA.svc/SaveMDAInfo';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sNAME: self.ruleForm.mdaNAME, //绘本名
									sCode: self.ruleForm.mdaCODE, //条码
									sPRES: self.ruleForm.mdaPRES, //出版社
									image: self.ruleForm.imgbase64, //封面
									audio: self.ruleForm.audioBase64, //音频
									sAUDL: self.ruleForm.mdaAUDL, //音频时长
									sSTOR: self.ruleForm.mdaSTOR, //故事介绍
									sLSFL:self.ruleForm.mdaLSFL, //类型分类
									sNLFL:self.ruleForm.mdaNLFL, //年龄分类
									sCBFL:self.ruleForm.mdaCBFL, //出版分类
								}
							)
							.then((response) => {
								this.submitFormLoading = false;
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '绘本添加失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('绘本添加成功'); // 编辑成功
										// 二次确认删除
										this.$confirm('是否继续新增绘本？', '提示', {
											confirmButtonText: '确定',
											cancelButtonText: '取消',
											type: 'warning'
										}).then(() => {
											this.reload();
										}).catch(() => {
											this.$router.push('/bookList') // 跳转路由到用户列表页
											this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件
											
											var indexs;
											for (let i = 0; i < this.COMM.tagsLists.length; i++) {
												if (this.COMM.tagsLists[i].name == "addBook") {
													console.log(this.COMM.tagsLists[i].name)
													indexs = i;
													break;
												}
											}
											this.closeTags(indexs);
										});
									}
								} else {
									this.$message({
										message: '绘本添加失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.submitFormLoading = false;
								this.$message({
									message: '绘本添加失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '绘本添加失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},

			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				// this.$router.go(-1);
				this.$router.push('/bookList') 
				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addBook") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.audio-uploader >>> .el-upload--text {
		border: none;
		width: 500px;
		height: 70px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	.audio-player {
		width: 300px;
		height: 70px;
	}
	
	.avatar-uploader >>> .el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		/* border-radius: 128px; */
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 200px;
		height: 280px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	.select-shop .el-input {
		width: 300px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.avatar-uploader .el-upload {
		width: 128px;
		height: 128px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 200px;
		height: 280px;
		line-height: 280px;
		text-align: center;
	}

	.avatar {
		width: 200px;
		height: 280px;
		display: block;
	}

	.cropper {
	    width: auto;
	    height: 300px;
	}
</style>
